import gql from "graphql-tag";

export default gql`
  mutation SignUpFromGoogleOAuthAccessToken($accessToken: String!, $timeZone: String!, $utms: UTMParametersInput) {
    signUpFromGoogleOAuthAccessToken(accessToken: $accessToken, timeZone: $timeZone, utms: $utms) {
      email
      isRecentlyCreatedUser
      accessToken
    }
  }
`;
